<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">İletişim Türü</label>
            <v-validator :errors="errors" parameter="ContactTypeId" :watch="type">
                <v-select-list v-model="type" placeholder="İletişim Türü" label="Name" :options="types"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Değer</label>
            <v-validator :errors="errors" parameter="Value" :watch="value.Value">
                <input type="text" class="form-control" v-model="value.Value" placeholder="Değer"/>
            </v-validator>
        </div>   
        <div class="col-12">
            <b-form-checkbox v-model="value.IsDefault">Varsayılan</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            types:[],
        }
    },

    mounted(){
        this.getTypes()

    },
    methods:{
        getTypes(){
            SystemDataApi.FirmContactType().then(res=>{
                this.types = res.data.Data
            })
        },
    },
    computed:{
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.ContactTypeId)
            },
            set:function(value){
                this.value.ContactTypeId = value?.Id || null
                this.value.ContactTypeName = value?.Name
                this.value.ContactTypeKey = value?.Key
            }
        },
    }
}
</script>

<style>

</style>